import axios from "axios";

import {
  TIIVII_GET_DEPLOYMENTS_ENDPOINT,
  TIIVII_GET_DEPLOYMENT_ENDPOINT,
  TIIVII_POST_DEPLOYMENT_ENDPOINT,
  TIIVII_PATCH_DEPLOYMENT_ENDPOINT,
  TIIVII_GET_DEPLOYMENT_STREAM_SOURCES_ENDPOINT,
} from "../utils/constants";
import { buildQueryParams, buildUrl, getOptions } from "./commonService";
import { LARGE_SELECT_LIMIT } from "../components/select/utils/select-constants";
import { apiPaginationConverter } from "../utils/api-pagination";

export const getDeploymentsService = (variables, callback, errorCallback) => {
  const config = getOptions({});
  let url = buildUrl(TIIVII_GET_DEPLOYMENTS_ENDPOINT, {});

  const { page, perPage, limit, contractId } = variables;

  const queryParams = buildQueryParams({
    limit: Number.isInteger(page) ? perPage : limit ?? LARGE_SELECT_LIMIT,
    offset: Number.isInteger(page) ? apiPaginationConverter(page, perPage).offset : undefined,
    contract_id: !!contractId ? contractId : undefined,
  });

  url = `${url}?${queryParams}`;

  axios
    .get(url, config)
    .then(response => {
      callback(response);
    })
    .catch(e => {
      errorCallback(e);
    });
};

export const getDeploymentStreamSourcesService = (deploymentId, variables, callback, errorCallback) => {
  const config = getOptions({});
  let url = buildUrl(TIIVII_GET_DEPLOYMENT_STREAM_SOURCES_ENDPOINT, { deploymentId });

  const { page, perPage, limit } = variables;

  const queryParams = buildQueryParams({
    limit: Number.isInteger(page) ? perPage : limit ?? LARGE_SELECT_LIMIT,
    offset: Number.isInteger(page) ? apiPaginationConverter(page, perPage).offset : undefined,
  });

  url = `${url}?${queryParams}`;

  axios
    .get(url, config)
    .then(response => {
      callback(response);
    })
    .catch(e => {
      errorCallback(e);
    });
};

export const updateDeploymentService = (variables, callback, errorCallback) => {
  const config = getOptions({});
  const { deploymentId, body } = variables;
  const url = buildUrl(TIIVII_PATCH_DEPLOYMENT_ENDPOINT, { deployment_id: deploymentId });

  axios
    .patch(url, body, config)
    .then(response => {
      callback(response.data);
    })
    .catch(e => {
      errorCallback(e);
    });
};

export const createDeploymentService = (variables, callback, errorCallback) => {
  const config = getOptions({});
  const { body } = variables;

  axios
    .post(TIIVII_POST_DEPLOYMENT_ENDPOINT, body, config)
    .then(response => {
      callback(response.data);
    })
    .catch(e => {
      errorCallback(e);
    });
};

export const getDeploymentService = (variables, callback, errorCallback) => {
  const config = getOptions({});
  const { deploymentId } = variables;
  const url = buildUrl(TIIVII_GET_DEPLOYMENT_ENDPOINT, { deployment_id: deploymentId });

  axios
    .get(url, config)
    .then(response => {
      callback(response.data);
    })
    .catch(e => {
      errorCallback(e);
    });
};
